import styled, { css } from 'styled-components'

export const Row = styled.div<{ $locked?: boolean }>(
  ({ theme, $locked }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['12']};
    padding: ${theme.space['12']} ${theme.space['16']};
    background: ${theme.colors.white};
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
    width: 100%;
    opacity: ${$locked ? 0.6 : 1};
    cursor: ${$locked ? 'not-allowed' : 'default'};

    &:hover {
      border-color: ${$locked ? theme.colors.gray400 : theme.colors.gray600};
    }
  `,
)

export const DragHandle = styled.div<{ $disabled?: boolean }>(
  ({ theme, $disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 2rem;
    color: ${$disabled ? theme.colors.gray400 : theme.colors.black300};
    cursor: ${$disabled ? 'not-allowed' : 'grab'};
  `,
)

export const Label = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    flex: 1;
    min-width: 0;
  `,
)
